export default __webpack_public_path__ + "static/media/tap.7af17a59.mp3";